







































import {
  defineComponent,
  useRouter,
  computed,
  ref,
} from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import CategoryProductSlide from "~/modules/catalog/category/components/views/CategoryProductSlide.vue";
import { useFacet } from "~/composables";
import { getUrlPathByCategory } from "~/modules/catalog/category/helpers";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import { useSlickOptions } from "~/stores/extensionApi";

export default defineComponent({
  name: "PromotionFilter",
  components: {
    SkeletonPlaceholder,
    LazyComponent,
    CategoryProductSlide,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const router = useRouter();
    const categoryStore = useCategoryStore();
    const categoryTree = computed(() => categoryStore.categories);
    const { loading } = useFacet();
    const indexActive = ref(0);
    const slickOptions = useSlickOptions();
    const menus = computed(() => props.item?.promotion_filter || []);
    const sizeGuide = computed(() => {
      if (!menus.value || menus.value.length === 0) {
        return null;
      }
      const selectedMenu = menus.value[indexActive.value];
      if (!selectedMenu || selectedMenu.value === undefined) {
        return null;
      }
      
      return selectedMenu.value;
    });

    const OptionItem = {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      navigation: true,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3.2,
          slidesPerGroup: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 32,
        },
      },
    };

    const goToCateById = async (row) => {
      const url_path = getUrlPathByCategory(row, categoryTree.value);
      if (url_path) {
        router.push(`/${url_path}`);
      }
    };

    return {
      OptionItem,
      goToCateById,
      menus,
      indexActive,
      loading,
      sizeGuide,
    };
  },
});
